import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { Toaster } from "sonner"
import { AuthProvider } from "@/components/auth/AuthProvider"
import { LoginScreen } from "@/components/auth/LoginScreen"
import { MainLayout } from "@/components/layout/MainLayout"
import {
  AdminKiPage,
  AdminSchemaPage,
  AdminTerminalPage,
  CallbackPage,
  ErfassungPage,
  HandbuchPage,
  MeldungDetailPage,
  OrganisationPage,
  ReviewPage,
  UebersichtPage,
} from "@/pages"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* basename = "/" (Vite base) — eigene Subdomain, kein Präfix (U6) */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AuthProvider>
          <Routes>
            <Route path="/callback" element={<CallbackPage />} />
            {/* Nur Dev: Anmeldeseite ansehen, ohne den Logto-Modus zu aktivieren */}
            {import.meta.env.DEV && (
              <Route path="/login-vorschau" element={<LoginScreen onLogin={() => {}} />} />
            )}
            <Route element={<MainLayout />}>
              <Route path="/" element={<UebersichtPage />} />
              <Route path="/melden" element={<ErfassungPage />} />
              <Route path="/meldungen/:id" element={<MeldungDetailPage />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/handbuch" element={<HandbuchPage />} />
              <Route path="/organisation" element={<OrganisationPage />} />
              <Route path="/admin/ki" element={<AdminKiPage />} />
              <Route path="/admin/schema" element={<AdminSchemaPage />} />
              <Route path="/admin/terminal" element={<AdminTerminalPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </QueryClientProvider>
  )
}
